import { AppRootElementBlueprint } from '@backstage/frontend-plugin-api';
import { SignalsDisplay } from '@backstage/plugin-signals';

/**
 * Mounts `<SignalsDisplay />` as an app-root element.
 *
 * In the legacy app `<SignalsDisplay />` was rendered directly inside
 * `app.createRoot(...)`. The `@backstage/plugin-signals/alpha` feature only
 * registers the signals API (`api:signals`) — it does not contribute the
 * display element — so it is wired explicitly here via
 * `AppRootElementBlueprint`, the new frontend system equivalent of the legacy
 * root mount.
 *
 * `AlertDisplay` and `OAuthRequestDialog` (the other two legacy root elements)
 * are provided automatically by the core `@backstage/plugin-app` package and
 * need no explicit wiring.
 */
export const signalsDisplayExtension = AppRootElementBlueprint.make({
  name: 'signals-display',
  params: {
    element: <SignalsDisplay />,
  },
});
